import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './MarketInfo.scss';
import MarketInfoInput from './MarketInfoInput';
import MarketInfoSearch from './MarketInfoSearch';
import MarketInfoTable from './MarketInfoTable';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/MarketInfoInputReducer';
import { resetMarketInfoSearch, setFirstSearchAlready, setTriggerFocusVesselName, setTriggerMarketInfoSearch } from './reducers/MarketInfoSearchReducer';

let triggerHotkeyAlready = false;

const MarketInfo: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "MarketInfo";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        dispatch(setTriggerSave((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        dispatch(setTriggerMarketInfoSearch((new Date()).getTime()));
                        dispatch(setFirstSearchAlready(true));
                        triggerHotkeyAlready = true;
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetMarketInfoSearch());
                        dispatch(setTriggerFocusVesselName((new Date()).getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <MarketInfoSearch></MarketInfoSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <MarketInfoInput></MarketInfoInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <MarketInfoTable>
                        </MarketInfoTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default MarketInfo;